module.exports = __webpack_public_path__ + "img/water-softener.6d13a7b8.jpg";